import { render, staticRenderFns } from "./TrackingApiLoader.vue?vue&type=template&id=2c96b6b7"
import script from "./TrackingApiLoader.vue?vue&type=script&lang=js"
export * from "./TrackingApiLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports